export default class Country {
    constructor(code, name) {
        this.code = code;
        this.name = name;
    }
}
